import multiApiClient from "./base";

const RESOURCE = "/amazon";

export const amazonApi = {
  // Get all credentials
  getAll(params) {
    return multiApiClient.get(`${RESOURCE}/`, { params });
  },

  // Get credential by ID
  get(id) {
    return multiApiClient.get(`${RESOURCE}/${id}`);
  },

  // Create new credential
  create(data) {
    return multiApiClient.post(`${RESOURCE}/`, data);
  },

  // Update credential
  update(id, data) {
    return multiApiClient.put(`${RESOURCE}/${id}`, data);
  },

  // Delete credential
  delete(id) {
    return multiApiClient.delete(`${RESOURCE}/${id}`);
  },

  // Test credentials (unsaved)
  test(data) {
    return multiApiClient.post(`${RESOURCE}/test`, data);
  },

  // Test saved credential
  testSaved(id) {
    return multiApiClient.post(`${RESOURCE}/${id}/test`);
  },

  // Toggle active status
  toggleActive(id) {
    return multiApiClient.post(`${RESOURCE}/${id}/toggle-active`);
  },
};
